import { FormCheckbox, FormInput, FormRadio, FormSelect } from "@/components";
import { IBrand, IBrandCreate } from "@/models";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
        FormSelect,
        FormCheckbox,
        FormRadio,
        FormInput,
    },
})
export default class NewBrand extends Vue {
    isOpen = true;

    public tab = "tab-1";

    public brand: IBrandCreate = {
        code: "",
        name: "",
        parentId: null,
    };

    get brands(): IBrand[] {
        return this.$store.getters["app/brands"];
    }

    @Watch("tab")
    resetForm(): void {
        this.reset();
    }

    @Watch("isOpen")
    returnToPreviousRoute(): void {
        if (!this.isOpen) {
            this.$router.back();
        }
    }

    reset(): void {
        this.brand = {
            code: "",
            name: "",
            parentId: null,
        };

        setTimeout(() => {
            const observer = this.$refs.observer as InstanceType<
                typeof ValidationObserver
            >;
            observer.reset();
        });
    }

    async submit(): Promise<void> {
        try {
            await this.$store.dispatch(`app/createBrand`, this.brand);
            this.$emit("success", `The brand has been successfully created`);
            this.$router.back();
        }
        catch (error) {
            this.$emit("error", error);
        }
    }

    close(): void {
        this.isOpen = false;
    }

    mounted(): void { }
}
